// src/components/TitleBar.jsx
import { useNavigate } from 'react-router-dom'
import { useDataStore } from '../stores/dataStore'
import { setSoundEnabled } from '../utils/sounds'

export default function TitleBar() {
  const navigate      = useNavigate()
  const connections   = useDataStore(s => s.connections)
  const activeAlerts  = useDataStore(s => s.getActiveAlerts())
  const soundEnabled  = useDataStore(s => s.soundEnabled)
  const setSoundStore = useDataStore(s => s.setSoundEnabled)

  const toggleSound = () => {
    const next = !soundEnabled
    setSoundEnabled(next)   // persist to localStorage
    setSoundStore(next)     // update store / UI
  }

  return (
    <div
      className="titlebar-drag"
      style={{
        height: 52,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px 0 80px', // 80px left for macOS traffic lights
        borderBottom: '1px solid var(--border-subtle)',
        flexShrink: 0,
        background: 'linear-gradient(to bottom, rgba(12, 16, 24, 0.9), transparent)',
      }}
    >
      <div className="no-drag" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* Logo mark */}
        <div style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 18,
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '0.05em',
        }}>
          Netwoke
        </div>
      </div>

      {/* Centered tagline */}
      <div className="no-drag" style={{ 
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        fontFamily: 'var(--font-body)',
        fontSize: 12,
        fontWeight: 400,
        color: '#00d4b8',
        letterSpacing: '0.02em',
      }}>
        Where Connection Meets Disclosure
      </div>

      {/* Left spacer for traffic lights */}
      <div style={{ width: 80 }} />

      {/* Right: status indicators */}
      <div className="no-drag" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div className="live-dot" />
          <span style={{ fontSize: 11, color: 'var(--text-tertiary)', fontFamily: 'var(--font-mono)' }}>
            LIVE · {connections.length} connections
          </span>
        </div>

        {/* Sound toggle */}
        <button onClick={toggleSound} title={soundEnabled ? 'Mute sounds' : 'Enable sounds'} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: soundEnabled ? 'var(--text-tertiary)' : 'rgba(220,232,245,0.2)',
          padding: '4px 6px', borderRadius: 6,
          transition: 'color 0.15s',
          display: 'flex', alignItems: 'center',
        }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--text-primary)'}
          onMouseLeave={e => e.currentTarget.style.color = soundEnabled ? 'var(--text-tertiary)' : 'rgba(220,232,245,0.2)'}
        >
          {soundEnabled ? (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
              <path d="M19.07 4.93a10 10 0 010 14.14"/>
              <path d="M15.54 8.46a5 5 0 010 7.07"/>
            </svg>
          ) : (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
              <line x1="23" y1="9" x2="17" y2="15"/>
              <line x1="17" y1="9" x2="23" y2="15"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  )
}
